/* eslint-disable no-extra-boolean-cast */
import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import AppError from "@/AppError";
import CustomControl from "@/components/Form/CustomControl";
import Section from "@/components/Section";
import { BusinePartnerEntity } from "@/constants/forms";
import SectionTitle from "@/components/SectionTitle";
import {
    defaultDealerId,
    CREATE,
    CUSTOMER_VALUE,
    DOWNGRADED_VALUE,
    EDIT,
    LEAD_VALUE,
    LEVEL2_VALUE,
    LEVEL3_VALUE,
    marketCodeKey,
    SPECIAL_CUSTOMER,
    SUB_TYPE_SCHEME_NAME,
    VIEW,
    CLEAR,
    BMW_ACCOUNT,
    FUTURE_PROSPECT,
    PASSED_TO_RETAILER,
    GreyMarketCheckResult_SellingNotAllowed,
    CoinCheckResult_SellingNotAllowed,
    RESET
} from "@/constants/constants";
import {
    CHECKBOX,
    DATE,
    LOOKUP,
    NUMBER,
    SELECT,
    SWITCH,
    TEXT,

} from "@/constants/forms";
import { BusinessPartnerDetailsContext } from "@/context/BusinessPartnerDetailsContext";
import apiUIData from "@/services/apiUI";
import { handleApiError } from "@/utils/handleApiError";
import { AppContext } from "@/context/AppContext";
import { bpLabel, filterRequiredFields, getNatioanlId3Label,isFieldDisabled, isFieldNotAllowedToViewValue, isFieldReadOnly, isFieldRequired } from "@/helperFunctions/businessPartners";
import { useQuery } from "@tanstack/react-query";
import {
    useBPMainInitialQueries,
    useBPRequiredFields,
    useFetchNewL2BPs,
} from "@/services/queries";
import VatNotApplicableDialog from "@/components/BusinessPartnerDetails/VatNotApplicableDialog";
import { useDebounce } from "@/hooks/useDebounce";
import { useTranslation } from "react-i18next";
import { showCoin,showGreySection } from "@/helperFunctions/generic";
import useFirstRender from "@/hooks/useFirstRender";
import { formatISO } from "date-fns";
import { bpFormLabels } from "@/constants/bpFormLabels";

const BPMainDetails = ({
    businessPartner,
    owningRetailer,
    control,
    filteredNkamOptions,
    mode,
    permissions,
    resetField,
    watch,
    setValue,
    termofcreditoptions,
    gettermsofcreditoption,
    shouldDisableNKAMStatus,
    register,
    isBpDetailsFetched,
    isGCDMEnabled,
    allowedStatuses,
    setCanSave
}) => {
    const {
        companyHierarchyOptions,
        downgradeReasonOptions,
        allowedLegalEntityTypeOptions,
        level2BusinessPartners,
        owningRetailerOptions,
        salesRegionOptions,
        subTypeOptions,
        owningKamServiceUsers,
        invoiceLanguageOptions,
        setSubTypeOptions,
        setLevel2BusinessPartners,
        greyResultOptions,
        requiredFields,
        setRequiredFields
    } = useContext(BusinessPartnerDetailsContext);
    const {
        countryOptions,
        userData: { [marketCodeKey]: marketCode, [defaultDealerId]: dealerId },
        coinResultStatuses,
        typeOptions,
        coinCheckSection,
    } = useContext(AppContext);
    const isFirstRender = useFirstRender();

    const [isEditable, setIsEditable] = useState(false);
    const [owningRetailerContactOptions, setOwningRetailerContactOptions] =
        useState([]);
    const [showOwningRetailerForBe, setShowOwningRetailerForBe] = useState(true);
    const [filteredReqFields, setFilteredReqFields] = useState(requiredFields);
    const [apiError, setApiError] = useState({});
    const companyHierarchy = watch(BusinePartnerEntity.companyHierarchy);
    const nationalId1Value = watch(BusinePartnerEntity.nationalId1);
    const vatNumberValue = watch(BusinePartnerEntity.vatNumber);
    const type = watch(BusinePartnerEntity.type);
    const l2ParentCompany = watch(BusinePartnerEntity.l2ParentCompany);
    const hasBillingAddress = watch(BusinePartnerEntity.hasBillingAddress);
    const gcdmId = watch(BusinePartnerEntity.gcdmId);
    const isDowngraded = watch(BusinePartnerEntity.nkamStatus) === DOWNGRADED_VALUE;
    const isFutureProspect = watch(BusinePartnerEntity.downgradeReason) === FUTURE_PROSPECT;
    const isPassedToRetailer = watch(BusinePartnerEntity.downgradeReason) === PASSED_TO_RETAILER;
    const [showOwingKaminEdit, setOwingKaminEdit] = useState(false);
    const [isStreetPOBoxCheck, setStreetPOBoxCheck] = useState(false);
    const [vatNotApplicableConfig, setVatNotApplicableConfig] = useState(false);
    const [cloneVatConfig, setCloneVatConfig] = useState(false);
    const isCustomerOrLead =
        watch(BusinePartnerEntity.nkamStatus) === LEAD_VALUE ||
        watch(BusinePartnerEntity.nkamStatus) === CUSTOMER_VALUE;
    const isGreyPerformed = watch(BusinePartnerEntity.greymarketcheckperformed);

    const isOwningRetailer = watch(BusinePartnerEntity.owningRetailer)?.id;
    const defaultInvoiceLanguage = watch(BusinePartnerEntity.invoiceLanguage);
    const bPVatNotApplicable = watch(BusinePartnerEntity.vatNotApplicable);
    const [vatNotApplicableModalString, setVatNotApplicableModalString] =
        useState("");
    const [vatNotApplicableModalMemo, setVatNotApplicableModalMemo] =
        useState("");
    const [manageGreyMarketConfig, setManageGreyMarketConfig] =
        useState("");
    const [marketsTNRMemo, setMarketsTNRMemo] = useState([]);
    const [businessPartnerL3EditFields, setBusinessPartnerL3EditFields] = useState([]);
    const [l2InputValue, setL2InputValue] = useState(null);
    const [inputReason, setInputReason] = useState(CLEAR);
    const [isTyping, setIsTyping] = useState(false);
    const [restrictL3toL2, setRestrictL3toL2] = useState(false);
    const [countyRequiredFields, setCountyRequiredFields] = useState([]);
    const [restrictedFields, setRestrictedFields] = useState([]);
    const [relabelFields, setRelabelFields] = useState([]);
    const [bpValidationRuleNationalID1, setBPValidationRuleNationalID1] =
        useState([]);
    const [
        isCountrySelectedId,
        isAddr2CountrySelectedId,
        selectedOwningRetailer,
        nkamStatus,
        address1Line1,
        postbox,
        address2Line1,
        address2PostBox,
        greyPerformed,
        greyMarketResult,
        downgradeReason,
        downgradeDate
    ] = watch([
        BusinePartnerEntity.country,
        BusinePartnerEntity.address2Country,
        BusinePartnerEntity.owningRetailer,
        BusinePartnerEntity.nkamStatus,
        BusinePartnerEntity.address1Line1,
        BusinePartnerEntity.postbox,
        BusinePartnerEntity.address2Line1,
        BusinePartnerEntity.address2PostBox,
        BusinePartnerEntity.greymarketcheckperformed,
        BusinePartnerEntity.greymarketcheckresult,
        BusinePartnerEntity.downgradeReason,
        BusinePartnerEntity.downgradeDate
    ]);
    const [nationalId1Label, setNationalId1Label] = useState(
        BusinePartnerEntity.nationalId1,
    );
    const [nationalId2Label, setNationalId2Label] = useState(
        BusinePartnerEntity.nationalId2,
    );
    const [nationalId3Label, setNationalId3Label] = useState(
        BusinePartnerEntity.nationalId3,
    );
    const [filteredInvoiceLanguages, setFilteredInvoiceLanguages] = useState([]);
    const [countyList, setCountyList] = useState([]);
    const [address2CountyList, setAddress2CountyList] = useState([]);
    const [disableNationalID1, setDisableNationalID1] = useState(
        businessPartner?.vatCloned,
    );
    const [showVatNotApplicableDialog, setShowVatNotApplicableDialog] =
        useState(false);
    const [disableStatusField, setDisableStatusField] = useState(false);
    const [readOnlyFields, setReadOnlyFields] = useState({});
    // const [disablegreySection, setDisableGreySection] = useState(false);
    const debouncedL2Value = useDebounce([l2InputValue], 500);
    const { t } = useTranslation();
  
    // uses equlity check to identify if a field is required or not.
    const isRequiredField = (schemaName) => {
        return isFieldRequired(schemaName, filteredReqFields, countyRequiredFields, marketCode, isCountrySelectedId);
    };

    const isReadOnlyField = (schemaName) => {
        return isFieldReadOnly(schemaName, readOnlyFields, isCountrySelectedId, marketCode);
    };

    const l2BpsListQuery = useFetchNewL2BPs(
        companyHierarchy,
        debouncedL2Value,
        mode,
        inputReason
    );
    const initialQueries = useBPMainInitialQueries(isBpDetailsFetched);

    const owningRetailerContactOptionsQuery = useQuery({
        queryKey: ["owningRetailerContactOptions", [isOwningRetailer]],
        queryFn: async ({ signal }) => {
            return apiUIData.getOwningRetailerContactOptions(
                isOwningRetailer,
                signal,
            );
        },
        enabled: Boolean(isOwningRetailer) && isBpDetailsFetched,
    });

    const getCountyListQuery = useQuery({
        queryKey: ["countyList", [isCountrySelectedId]],
        queryFn: async ({ signal }) => {
            resetField("county");
            return apiUIData.getCountyList(isCountrySelectedId, signal);
        },
        enabled: Boolean(isCountrySelectedId),
    });

    const getBillingCountyListQuery = useQuery({
        queryKey: ["countyList", [isAddr2CountrySelectedId]],
        queryFn: async ({ signal }) => {
            resetField("address2County");
            return apiUIData.getCountyList(isAddr2CountrySelectedId, signal);
        },
        enabled: Boolean(isAddr2CountrySelectedId),
    });

    const getSubTypeOptionsQuery = useQuery({
        queryKey: ["subTypeOptions", [type]],
        queryFn: async ({ signal }) => {
            resetField("subType");
            return apiUIData.getSubTypeOptions(type?.id || null, signal);
        },
        enabled: isBpDetailsFetched && Boolean(mode !== VIEW),
    });

    const isInitialQueriesLoading = initialQueries.some((q) => q.isLoading);

    useEffect(() => {
        setValue("termOfCredit", businessPartner?.termOfCredit?.id);
        if (countryOptions.length) {
            let userMarketValue = countryOptions.find(
                (c) => c.isoCode === marketCode,
            )?.value;
            !businessPartner?.address2Country?.value && setValue(BusinePartnerEntity.address2Country, userMarketValue);
            !businessPartner?.country?.value && !isCountrySelectedId &&setValue(BusinePartnerEntity.country, userMarketValue);
        }
    }, []);

    useEffect(() => {
        if (isInitialQueriesLoading) {
            return;
        }
        const isError = initialQueries.some((q) => q.isError);
        if (isError) {
            let error = initialQueries.find((q) => q.isError)?.error;
            setApiError(handleApiError(error));
        }
        if (initialQueries.every((q) => q.isSuccess)) {
            const { description: NationalId1Label, booleanValue: Nat1Boolean } =
                initialQueries[0]?.data?.data?.result || {};
            const { description: NationalId2Label, booleanValue: Nat2Boolean } =
                initialQueries[1]?.data?.data?.result || {};
            const { booleanValue: allowOwningKamEdit } =
                initialQueries[3]?.data?.data?.result || {};
            const { booleanValue: streetPOBoxCheck } =
                initialQueries[4]?.data?.data?.result || {};
            const { booleanValue: vatNotApplicableConfigResult } =
                initialQueries[6]?.data?.data?.result || {};
            let vatNotApplicableConfigMessageMemo =
                initialQueries[7]?.data?.data?.result?.description || {};
            let vatNotApplicableConfigMessageString =
                initialQueries[7]?.data?.data?.result?.stringValue || {};
            const { booleanValue: cloneVatConfig } =
                initialQueries[8]?.data?.data?.result || {};
            let manageGreyMarketConfigString =
                initialQueries[9]?.data?.data?.result?.stringValue || {};
            let {stringValue: countyRequiredFieldsString, booleanValue: countyRequiredFieldsBool} = initialQueries[11]?.data?.data?.result || {};
            let {stringValue: countyReadOnlyFieldsString, booleanValue: countyReadOnlyFieldsBool} = initialQueries[13]?.data?.data?.result || {};
            let {description: relabelFieldsString, booleanValue: relabelFieldsBool} = initialQueries[14]?.data?.data?.result || {};
            let marketsTNRMemoVal = initialQueries[15]?.data?.data?.result?.description || "";
            let businessPartnerL3EditFieldsVal = initialQueries[16]?.data?.data?.result?.stringValue || {};
            let bpValidationRuleNationalID1  = initialQueries[17]?.data?.data?.result || {};
            setNationalId1Label(
                (Nat1Boolean && NationalId1Label) ||
                t("businessPartnerDetailPage.mainDetails.nationalId1"),
            );
            setNationalId2Label(
                (Nat2Boolean && NationalId2Label) ||
                t("businessPartnerDetailPage.mainDetails.nationalId2"),
            );
            if (allowOwningKamEdit) {
                if (mode === EDIT) {
                    setOwingKaminEdit(true);
                }
            } else {
                setOwingKaminEdit(false);
            }
            if (streetPOBoxCheck) {
                if (mode != VIEW) {
                    setStreetPOBoxCheck(true);
                }
            } else {
                setStreetPOBoxCheck(false);
            }
            if (
                vatNotApplicableConfigResult &&
                vatNotApplicableConfigResult === true
            ) {
                setVatNotApplicableConfig(true);
            }
            if (vatNotApplicableConfigMessageString) {
                setVatNotApplicableModalString(vatNotApplicableConfigMessageString);
            }
            if (vatNotApplicableConfigMessageMemo) {
                setVatNotApplicableModalMemo(vatNotApplicableConfigMessageMemo);
            }
            if (cloneVatConfig && cloneVatConfig == true) {
                setCloneVatConfig(true);
            }
            if (manageGreyMarketConfigString) {
                setManageGreyMarketConfig(JSON.parse(manageGreyMarketConfigString??""));
            }
            setRestrictL3toL2(initialQueries[10].data?.data?.result?.booleanValue);
            countyRequiredFieldsBool && setCountyRequiredFields(JSON.parse(countyRequiredFieldsString));
            setRestrictedFields([...fetchAccountRestrictedFields(initialQueries[12].data?.data?.result)]);
            countyReadOnlyFieldsBool && countyReadOnlyFieldsString && setReadOnlyFields(JSON.parse(countyReadOnlyFieldsString));
            relabelFieldsString && setRelabelFields(JSON.parse(relabelFieldsString));
            if (marketsTNRMemoVal && marketsTNRMemoVal !== null && marketsTNRMemoVal !== undefined){
                setMarketsTNRMemo([...marketsTNRMemoVal.split(",")]);
            }
            if(businessPartnerL3EditFieldsVal !== null && businessPartnerL3EditFieldsVal !== undefined){
                let parsedJson = JSON.parse(businessPartnerL3EditFieldsVal || "[]");         
                setBusinessPartnerL3EditFields(parsedJson);
            }
            if (bpValidationRuleNationalID1 !== null && bpValidationRuleNationalID1 !== undefined) {
                setBPValidationRuleNationalID1(bpValidationRuleNationalID1);
            }
        }
    }, [isInitialQueriesLoading]);

    useEffect(() => {
        const { booleanValue, description } = initialQueries[2].data?.data?.result || {};
        const defaultLabel = t("businessPartnerDetailPage.mainDetails.nationalId3");
        const parsedLabel = getNatioanlId3Label(
            description,
            booleanValue,
            defaultLabel,
            isCountrySelectedId,
        );
        setNationalId3Label(booleanValue ? parsedLabel : defaultLabel);
    }, [initialQueries[2]?.dataUpdatedAt, isCountrySelectedId]);

    useEffect(() => {
        if (initialQueries[5].isSuccess && invoiceLanguageOptions.length) {
            const { stringValue, description } =
                initialQueries[5].data?.data?.result || {};
            const statusValues = description?.split("|") || [];
            const filteredLanguages = invoiceLanguageOptions.filter((option) =>
                statusValues.includes(option.value.toString()),
            );
            setFilteredInvoiceLanguages(filteredLanguages);
            if (!defaultInvoiceLanguage) {
                setValue(BusinePartnerEntity?.invoiceLanguage, stringValue);
            }
        }
    }, [invoiceLanguageOptions, initialQueries[5]?.dataUpdatedAt]);


    useEffect(() => {
        if (owningRetailerContactOptionsQuery.isLoading) {
            return;
        }
        if (owningRetailerContactOptionsQuery.isError) {
            let error = owningRetailerContactOptionsQuery.error;
            setApiError(handleApiError(error));
        }
        if (owningRetailerContactOptionsQuery.isSuccess) {
            setOwningRetailerContactOptions(
                owningRetailerContactOptionsQuery.data.data.result,
            );
        }
    }, [
        owningRetailerContactOptionsQuery.dataUpdatedAt,
        owningRetailerContactOptionsQuery.errorUpdatedAt,
    ]);

    useEffect(() => {
        if (getCountyListQuery.isError) {
            let error = getCountyListQuery.error;
            setApiError(handleApiError(error));
        }
        if (getCountyListQuery.isSuccess) {
            setCountyList(getCountyListQuery.data.data.result);
        }
    }, [getCountyListQuery.dataUpdatedAt, getCountyListQuery.errorUpdatedAt]);

    useEffect(() => {
        if (getBillingCountyListQuery.isError) {
            let error = getBillingCountyListQuery.error;
            setApiError(handleApiError(error));
        }
        if (getBillingCountyListQuery.isSuccess) {
            setAddress2CountyList(getBillingCountyListQuery.data.data.result);
        }
    }, [
        getBillingCountyListQuery.dataUpdatedAt,
        getBillingCountyListQuery.errorUpdatedAt,
    ]);

    useEffect(() => {
        if (getSubTypeOptionsQuery?.isError) {
            let error = getSubTypeOptionsQuery?.error;
            setApiError(handleApiError(error));
        }
        if (getSubTypeOptionsQuery?.isSuccess) {
            const subTypesOptions = getSubTypeOptionsQuery?.data?.data?.result;
            let subTypes = subTypesOptions.filter(x => !(x.restrictedDealerPortal));
            setSubTypeOptions(subTypes);
        }
    }, [
        getSubTypeOptionsQuery?.dataUpdatedAt,
        getSubTypeOptionsQuery?.errorUpdatedAt,
        getSubTypeOptionsQuery?.status,
    ]);

    const fetchLabels = (schemaName) => {
        const label = bpLabel(schemaName, marketCode, relabelFields);
        return label || t(bpFormLabels[schemaName]);
    }
    useEffect(() => {
        if (l2BpsListQuery?.isFetching) return;
        if (l2BpsListQuery?.isError) {
            setApiError(handleApiError(l2BpsListQuery?.error));
        }
        if (l2BpsListQuery?.isSuccess) {
            setLevel2BusinessPartners(l2BpsListQuery?.data?.data?.result || []);
        }
        setIsTyping(false);
    }, [l2BpsListQuery?.dataUpdatedAt, l2BpsListQuery?.errorUpdatedAt]);

    useEffect(() => {
        if (marketCode === "BE" && permissions !== null  && permissions?.agencyModelRestricted) {
            setShowOwningRetailerForBe(false);
        }
    }, [companyHierarchy, permissions]);

    useEffect(() => {
        if (permissions) {
            permissionToEditOwningRetailer();
        }
    }, [companyHierarchy, permissions, restrictedFields]);
    useEffect(() => {
        gettermsofcreditoption(type?.id, companyHierarchy, l2ParentCompany, marketCode, marketsTNRMemo); // TODO how to get the bpid here
    }, [l2ParentCompany, type?.id]);

    useEffect(() => {
        AddtoRequriedFields(type);
        if (inputReason === RESET) {
            resetFieldTermofCredit();
            setValue(BusinePartnerEntity.subType, null);
        }
    }, [type?.id]);
    // as streetpobox config is fetched from serve, need to be part of dependency array.
    useEffect(() => {
        if (isStreetPOBoxCheck) {
            setFilteredReqFields(
                filterRequiredFields(
                    requiredFields,
                    address1Line1,
                    postbox,
                    address2Line1,
                    address2PostBox,
                    hasBillingAddress,
                ),
            );
        } else {
            setFilteredReqFields(requiredFields);
        }
    }, [
        isStreetPOBoxCheck,
        address1Line1,
        postbox,
        address2Line1,
        address2PostBox,
        requiredFields,
    ]);

    useEffect(() => {
        const statusDisable = statusDisableValidation();
        setDisableStatusField(statusDisable)
        // Created for nkam-24358
        // clubbing here instead of new ueseffecthook
        // TODO: check why setValue is not used as its a standard way of setting value to dynamic form fields.
        if(companyHierarchy === LEVEL2_VALUE){
            setValue(BusinePartnerEntity.l2ParentCompany,"",{ shouldDirty: true });
            setL2InputValue(null);
        }
    }, [
        shouldDisableNKAMStatus,
        gcdmId,
        companyHierarchy,
        businessPartner?.coinCheckResult?.value,
        businessPartner?.greyMarketCheckResult?.value,
    ]);

    // TODO: make it generic to fetch restrictedfields for any entity.
    const fetchAccountRestrictedFields = (config) => {
        // handle null scenarios.
        if (config === undefined || config === null
            || !config?.booleanValue || config?.stringValue === undefined
            || config?.stringValue === null || config?.stringValue === "") return [];

        const jsonData = JSON.parse(config.stringValue || "");
        const restrictedEntities = jsonData?.restrictedEntities || [];
        const account = restrictedEntities.find((entity) => entity?.schemaName == "account")
        const marketFilteredRestrictedFields = account?.restrictedFields?.filter((restrictedField) => restrictedField?.markets?.includes(marketCode))
        const restrictedFields = []
        for (const restrictedField of marketFilteredRestrictedFields) {
            if (restrictedField?.schemaName !== undefined || restrictedField?.schemaName !== null || restrictedField?.schemaName !== "") {
                restrictedFields.push(restrictedField.schemaName);
            }
        }

        return restrictedFields;
    }

    const statusDisableValidation = () => {
        if (
            shouldDisableNKAMStatus ||
            (!Boolean(gcdmId) && isGCDMEnabled)
        ) {
            return true;
        }
        else if ((businessPartner?.coinCheckResult?.value === CoinCheckResult_SellingNotAllowed || businessPartner?.nkamStatus?.value === CUSTOMER_VALUE)
                 && coinCheckSection?.Markets?.includes(marketCode)) {
            return true;
        }
        else if (greyMarketResult?.value === GreyMarketCheckResult_SellingNotAllowed && getShowGreySectionBool()) {
            return true;
        }
        else {
            return false;
        }
    }
    const AddtoRequriedFields = (type) => {
        if (type?.name === SPECIAL_CUSTOMER) {
            setFilteredReqFields([...requiredFields, SUB_TYPE_SCHEME_NAME]);
        } else {
            if (requiredFields?.length) {
                let filteredRequiredFields = requiredFields?.filter(
                    function (schemaName) {
                        return schemaName !== SUB_TYPE_SCHEME_NAME;
                    },
                );
                setFilteredReqFields(filteredRequiredFields);
            }
        }
    };

    const permissionToEditOwningRetailer = () => {
        const isRetailerAllowedToEdit = !isFieldNotAllowedToViewValue(restrictedFields, BusinePartnerEntity.owningRetailer);
        if (companyHierarchy === LEVEL2_VALUE && isRetailerAllowedToEdit) {
            setIsEditable(true);
        } else {
            resetField(BusinePartnerEntity.owningRetailer, {
                defaultValue: businessPartner?.owningRetailer,
            });
            resetField(BusinePartnerEntity.owningRetailerContact, {
                defaultValue: businessPartner?.owningRetailerContact,
            });
            setIsEditable(false);
        }
    };

    useEffect(() => {
        if (!isDowngraded) {
            resetDowngradeFields();
        }
    }, [isDowngraded]);

    useEffect(() => {
        if (l2InputValue) {
            setLevel2BusinessPartners([]);
            setIsTyping(true);
        }
    }, [l2InputValue]);

    const resetFieldTermofCredit = () => {
        resetField(BusinePartnerEntity.termOfCredit);
    };
    // Modified for NKAM-23845
    // Removed resetFieldsRelatedToLeadStatus functions functionality as it's not a valid functionality.
    // It was developed as part of NKAM-12254 & NKAM-13534.
    // But as per the mentioned tickets the functionality is to make the field mandatory and not to reset the fields. Hence removing this functionality.
    // To make the fields mandatory we have now configs based on status. So no need to make the field mandatory manually.

    const resetDowngradeFields = () => {
        resetField(BusinePartnerEntity.downgradeDate);
        resetField(BusinePartnerEntity.futureProspectDate);
        resetField(BusinePartnerEntity.downgradeDescription);
        resetField(BusinePartnerEntity.downgradeReason);
    };

    useEffect(() => {
        if (!hasBillingAddress) {
            resetBillingAddressFields();
        }
    }, [hasBillingAddress]);

    const resetBillingAddressFields = () => {
        resetField(BusinePartnerEntity.address2BuildingNumber);
        resetField(BusinePartnerEntity.address2Line1);
        resetField(BusinePartnerEntity.address2Line2);
        resetField(BusinePartnerEntity.address2Line3);
        resetField(BusinePartnerEntity.address2PostCode);
        resetField(BusinePartnerEntity.address2PostBox);
        resetField(BusinePartnerEntity.address2City);
        resetField(BusinePartnerEntity.address2County);
        resetField(BusinePartnerEntity.address2SalesRegion);
    };

    const handleCountryChange = () => {
        setDisableNationalID1(false);
        setValue(BusinePartnerEntity.county, "", { shouldDirty: true })
    };

    const handleCountry2Change = () => {
        setValue(BusinePartnerEntity.address2County,"", { shouldDirty: true })
    };

    useEffect(() => {
        if (!selectedOwningRetailer) {
            let defaultDealer = owningRetailerOptions.find(
                (retailer) => retailer.id === dealerId,
            );
            if (!defaultDealer && owningRetailerOptions.length) {
                setValue(BusinePartnerEntity.owningRetailer, owningRetailerOptions[0]);
            } else {
                setValue(BusinePartnerEntity.owningRetailer, defaultDealer);
            }
        }
    }, [owningRetailerOptions]);

    useEffect(() => {
        if(!isFirstRender) {
            if(greyPerformed) {
                setValue(BusinePartnerEntity.greymarketcheckdate, formatISO(new Date()).toString(), { shouldDirty: true });
            } else {
                setValue(BusinePartnerEntity.greymarketcheckdate, "", { shouldDirty: true });
                setValue(BusinePartnerEntity.greymarketcheckresult, null, { shouldDirty: true });
            }
        }
    },[greyPerformed]);

    useEffect(() => {
        if (mode === EDIT && (manageGreyMarketConfig !== "" || manageGreyMarketConfig !== undefined)) {
            const isGreySectionEnabled = getShowGreySectionBool();
            if (greyMarketResult?.value === GreyMarketCheckResult_SellingNotAllowed && isGreySectionEnabled && greyPerformed && allowedStatuses.includes(DOWNGRADED_VALUE.toString())) {
                setValue(BusinePartnerEntity.nkamStatus, DOWNGRADED_VALUE, { shouldDirty: true });
                setDisableStatusField(true);
            } else {
                const statusDisable = statusDisableValidation();
                setDisableStatusField(statusDisable)
            }
        }
    }, [greyMarketResult, type, mode, manageGreyMarketConfig])

    useEffect(() => {
        if (greyMarketResult?.value === GreyMarketCheckResult_SellingNotAllowed) {
            if (downgradeReason === undefined || downgradeReason === "" || downgradeReason === null) {
                const reasonSellingNotAllowed = downgradeReasonOptions.find((f) => f.value === 174640008);
                if (reasonSellingNotAllowed.value) {
                    setValue(BusinePartnerEntity.downgradeReason, reasonSellingNotAllowed.value, { shouldDirty: true });
                }
            }
            if (downgradeDate === undefined || downgradeDate === "" || downgradeDate === null) {
                setValue(BusinePartnerEntity.downgradeDate, formatISO(new Date()).toString(), { shouldDirty: true });
            }
        } else {
            resetDowngradeFields();
        }
    }, [greyMarketResult])

    useEffect(() => {
        return () => {
            // queryClient.invalidateQueries();
        };
    }, []);

    const l2l3EnabledFieldConditionOnHierarchy = () => {

        return companyHierarchy === LEVEL3_VALUE;

    };

    const checkAccountTypeIsFleet = () => {

        return type?.name === "Fleet";
    }

    const checkPortalEditField = (field) => {
    if (businessPartnerL3EditFields.length != 0) {
        let isMixedMarket = businessPartnerL3EditFields.BPEditFields[0].EditFields.Markets.includes(marketCode);
            if (isMixedMarket)
            {
                let fields = businessPartnerL3EditFields.BPEditFields[0].EditFields.Fields;
                if (fields?.length > 0 ) {
                    let fieldValue = fields.find(x => x.SchemaName.toLowerCase() === field.toLowerCase());
                    if (fieldValue && fieldValue !== undefined) {
                        let existHierarchy = fieldValue.Hierarchy.map(Number).includes(companyHierarchy);
                        if (existHierarchy) {
                            return fieldValue.Disabled;
                        }
                        else {
                            return l2l3EnabledFieldConditionOnHierarchy();
                        }
                    }
                    else{
                        return l2l3EnabledFieldConditionOnHierarchy();
                    }
                }
                else{
                    return l2l3EnabledFieldConditionOnHierarchy();
                }
            }
            else{
                return l2l3EnabledFieldConditionOnHierarchy();
            }
        }
        else{
            return l2l3EnabledFieldConditionOnHierarchy();
        }
    };

    const vatNotApplicableOnChange = () => {
        setShowVatNotApplicableDialog(true);
    };

    const vatNotApplicablehandleOk = () => {
        if (bPVatNotApplicable) {
            // VatNotApplicable false to true "Checked"
            setValue(BusinePartnerEntity?.vatNumber, "");
        }

        if (businessPartner?.vatCloned) {
            setValue(BusinePartnerEntity?.nationalId1, "");
        }
        setShowVatNotApplicableDialog(false);
    };

    const vatNotApplicablehandleClose = () => {
        setValue(BusinePartnerEntity?.vatNotApplicable, !bPVatNotApplicable);
        setShowVatNotApplicableDialog(false);
    };

    const getShowCoinBool = () => {
        if (!coinCheckSection?.Markets?.includes(marketCode))
           return false;
        else return showCoin(BMW_ACCOUNT, type, typeOptions);
    }
    const getShowGreySectionBool = () => {

        return showGreySection( typeOptions,type,manageGreyMarketConfig,marketCode);
    }

    const nationalId1OnChange = () => {
        if (bpValidationRuleNationalID1 != null && bpValidationRuleNationalID1 != "") {
            if (bpValidationRuleNationalID1.booleanValue) {
                if (bpValidationRuleNationalID1.description != null && bpValidationRuleNationalID1.description != "" && bpValidationRuleNationalID1.description !== undefined) {
                    var customRuleJson = JSON.parse(bpValidationRuleNationalID1.description);
                    if (customRuleJson !== null && customRuleJson !== undefined && customRuleJson !== "") {
                        if (customRuleJson.CustomRule.length > 0) {
                            if (customRuleJson.CustomRule[0].CreateTSEvent === 'true' && customRuleJson.CustomRule[0].Rule === "CompareSequence") {
                                if (vatNumberValue !== null && vatNumberValue !== "" && vatNumberValue !== undefined && nationalId1Value !== null && nationalId1Value !== "" && nationalId1Value !== undefined) {
                                    let vatNumber = vatNumberValue.replace(/\D/g, '');
                                    if (vatNumber !== nationalId1Value) {
                                        setApiError(handleApiError({ message: customRuleJson.CustomRule[0].ErrorMessage, statusCode: "Business Partner"}));
                                        setCanSave(false)
                                    }
                                    else {
                                        setCanSave(true)
                                    }
                                }
                                else {
                                    setCanSave(true)
                                }
                            }
                        }
                    }
                }
            }
            
        }
       
    }

    /**
     *   @variation NKAM-13218 / Sai Padamata / 09-01-2023 / Business Partner - CRM+Portal - Form Cleansing
     */
    // TODO we have make name parameter in sync with CRM field internalName
    // and moved these orphan strings to a file, its getting un managable now.
    // will fix in recurrent PR
    return (
        <>
            <Section id="details">
                <SectionTitle
                    category={true}
                    title={t("businessPartnerDetailPage.mainDetails.sectionTitle")}
                />
            </Section>

            <Section>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={t("businessPartnerDetailPage.mainDetails.name")}
                            mode={mode}
                            name={BusinePartnerEntity.name}
                            required={true}
                            type={TEXT}
                            view={businessPartner?.name}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.legalName)}
                            maxLength={160}
                            mode={mode}
                            name={BusinePartnerEntity.legalName}
                            required={true}
                            type={TEXT}
                            view={businessPartner?.legalName}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.vatNumber)}
                            mode={mode}
                            name={BusinePartnerEntity.vatNumber}
                            required={
                                bPVatNotApplicable
                                    ? false
                                    : isRequiredField(BusinePartnerEntity.vatNumber)
                            }
                            type={TEXT}
                            view={businessPartner?.vatNumber}
                            disabled={bPVatNotApplicable}
                            blur={nationalId1OnChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.representedBy)}
                            mode={mode}
                            name={BusinePartnerEntity.representedBy}
                            type={TEXT}
                            view={businessPartner?.representedBy}
                            required={
                                bPVatNotApplicable
                                    ? false
                                    : isRequiredField("bmw_representedby")
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.companyHierarchy)}
                            mode={mode}
                            options={companyHierarchyOptions}
                            name={BusinePartnerEntity.companyHierarchy}
                            required={true}
                            type={SELECT}
                            view={businessPartner?.companyHierarchy?.name}
                            disabled = {businessPartner?.companyHierarchy?.value===LEVEL3_VALUE && restrictL3toL2}
                        />
                    </Grid>

                    {vatNotApplicableConfig && (
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.vatNotApplicable)}
                                mode={mode}
                                name={BusinePartnerEntity.vatNotApplicable}
                                type={CHECKBOX}
                                view={businessPartner?.vatNotApplicable}
                                onCheckboxChange={vatNotApplicableOnChange}
                            />
                        </Grid>
                    )}

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.invoiceLanguage)}
                            disabled={checkPortalEditField(BusinePartnerEntity.invoiceLanguage) ? !isEditable : false } 
                            mode={mode}
                            options={filteredInvoiceLanguages}
                            name={BusinePartnerEntity.invoiceLanguage}
                            type={SELECT}
                            view={businessPartner?.invoiceLanguage?.name}
                            required={isRequiredField("bmw_invoicelanguage")}
                            showPlaceholderOption={!isRequiredField("bmw_invoicelanguage")}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.url)}
                            mode={mode}
                            name={BusinePartnerEntity.url}
                            type={TEXT}
                            url={businessPartner?.url}
                            view={businessPartner?.url}
                            required={isRequiredField("websiteurl")}
                        />
                    </Grid>

                    {companyHierarchy === LEVEL3_VALUE && (
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.l2ParentCompany)}
                                mode={mode}
                                name={BusinePartnerEntity.l2ParentCompany}
                                options={level2BusinessPartners}
                                required={true}
                                type={LOOKUP}
                                view={businessPartner?.l2ParentCompany?.name}
                                url={`/businesspartner/${businessPartner?.l2ParentCompany?.id}`}
                                setInputValue={setL2InputValue}
                                inputValue={l2InputValue}
                                loading={l2BpsListQuery?.isFetching || isTyping}
                                noOptionsText="No options. Refine your search."
                                shouldFilterManually={false}
                                setInputReason={setInputReason}
                            />
                        </Grid>
                    )}

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.mainPhone)}
                            mode={mode}
                            name={BusinePartnerEntity.mainPhone}
                            type={TEXT}
                            maxLength={50}
                            view={businessPartner?.mainPhone}
                            required={isRequiredField("telephone1")}
                        />
                    </Grid>
                </Grid>
            </Section>

            <Section>
                <SectionTitle title="Main Address" />

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.buildingNumber)}
                            mode={mode}
                            name={BusinePartnerEntity.buildingNumber}
                            type={TEXT}
                            required={isRequiredField("bmw_address1buildingnumber")}
                            view={businessPartner?.buildingNumber}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.address1Line1)}
                            mode={mode}
                            name={BusinePartnerEntity.address1Line1}
                            required={isRequiredField("address1_line1")}
                            type={TEXT}
                            view={businessPartner?.address1Line1}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.address1Line2)}
                            mode={mode}
                            name={BusinePartnerEntity.address1Line2}
                            type={TEXT}
                            view={businessPartner?.address1Line2}
                            required={isRequiredField("address1_line2")}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.address1Line3)}
                            mode={mode}
                            name={BusinePartnerEntity.address1Line3}
                            type={TEXT}
                            view={businessPartner?.address1Line3}
                            required={isRequiredField("address1_line3")}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.address1PostCode)}
                            mode={mode}
                            name={BusinePartnerEntity.address1PostCode}
                            required={isRequiredField("address1_postalcode")}
                            type={TEXT}
                            maxLength={10}
                            view={businessPartner?.address1PostCode}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.postbox)}
                            mode={mode}
                            name={BusinePartnerEntity.postbox}
                            type={TEXT}
                            maxLength={20}
                            view={businessPartner?.postbox}
                            required={isRequiredField("address1_postofficebox")}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.address1City)}
                            mode={mode}
                            name={BusinePartnerEntity.address1City}
                            required={isRequiredField("address1_city")}
                            type={TEXT}
                            view={businessPartner?.address1City}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.country)}
                            mode={mode}
                            name={BusinePartnerEntity.country}
                            options={countryOptions}
                            required={isRequiredField("bmw_country")}
                            type={SELECT}
                            view={businessPartner?.country?.name}
                            onChange={handleCountryChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.county)}
                            mode={mode}
                            options={countyList}
                            name={BusinePartnerEntity.county}
                            type={LOOKUP}
                            view={businessPartner?.county?.name}
                            required={isRequiredField(BusinePartnerEntity.county)}
                            disabled={isReadOnlyField(BusinePartnerEntity.county)}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.salesRegion)}
                            mode={mode}
                            name={BusinePartnerEntity.salesRegion}
                            options={salesRegionOptions}
                            type={LOOKUP}
                            view={businessPartner?.salesRegion?.name}
                            required={isRequiredField("bmw_salesregionid")}
                        />
                    </Grid>
                    
                    {(mode === CREATE ? true : !hasBillingAddress) && <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.hasBillingAddress)}
                            mode={mode}
                            name={BusinePartnerEntity.hasBillingAddress}
                            type={SWITCH}
                        />
                    </Grid>}
                </Grid>
            </Section>

            {hasBillingAddress && (
                <Section>
                    <SectionTitle
                        title={t("businessPartnerDetailPage.mainDetails.billingAddress")}
                    />

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2BuildingNumber)}
                                mode={mode}
                                name={BusinePartnerEntity.address2BuildingNumber}
                                type={TEXT}
                                required={isRequiredField("bmw_address2buildingnumber")}
                                view={businessPartner?.address2BuildingNumber}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2Line1)}
                                mode={mode}
                                name={BusinePartnerEntity.address2Line1}
                                required={isRequiredField("address2_line1")}
                                type={TEXT}
                                view={businessPartner?.address2Line1}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2Line2)}
                                mode={mode}
                                name={BusinePartnerEntity.address2Line2}
                                type={TEXT}
                                required={isRequiredField("address2_line2")}
                                view={businessPartner?.address2Line2}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2Line3)}
                                mode={mode}
                                name={BusinePartnerEntity.address2Line3}
                                required={isRequiredField("address2_line3")}
                                type={TEXT}
                                view={businessPartner?.address2Line3}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2PostCode)}
                                mode={mode}
                                name={BusinePartnerEntity.address2PostCode}
                                required={isRequiredField("address2_postalcode")}
                                type={TEXT}
                                maxLength={10}
                                view={businessPartner?.address2PostCode}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2PostBox)}
                                mode={mode}
                                name={BusinePartnerEntity.address2PostBox}
                                maxLength={20}
                                type={TEXT}
                                view={businessPartner?.address2PostBox}
                                required={isRequiredField("address2_postofficebox")}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2City)}
                                mode={mode}
                                name={BusinePartnerEntity.address2City}
                                type={TEXT}
                                view={businessPartner?.address2City}
                                required={isRequiredField("address2_city")}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2Country)}
                                mode={mode}
                                name={BusinePartnerEntity.address2Country}
                                options={countryOptions}
                                required={isRequiredField("bmw_address2country")}
                                type={SELECT}
                                view={businessPartner?.address2Country?.name}
                                onChange={handleCountry2Change}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2County)}
                                mode={mode}
                                name={BusinePartnerEntity.address2County}
                                type={LOOKUP}
                                options={address2CountyList}
                                view={businessPartner?.address2County?.name}
                                required={isRequiredField("bmw_address2_countyid")}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.address2SalesRegion)}
                                mode={mode}
                                name={BusinePartnerEntity.address2SalesRegion}
                                options={salesRegionOptions}
                                required={isRequiredField("bmw_address2salesregionid")}
                                type={LOOKUP}
                                view={businessPartner?.address2SalesRegion?.name}
                            />
                        </Grid>
                    </Grid>
                </Section>
            )}

            <Section>
                <SectionTitle title={t("businessPartnerDetailPage.mainDetails.type")} />

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            disabled={checkAccountTypeIsFleet() ? (companyHierarchy === LEVEL3_VALUE) : false}
                            label={fetchLabels(BusinePartnerEntity.type)}
                            mode={mode}
                            name={BusinePartnerEntity.type}
                            options={typeOptions}
                            required={
                                companyHierarchy === LEVEL3_VALUE
                                    ? false
                                    : isCustomerOrLead || isRequiredField("bmw_accounttypeid")
                            }
                            type={LOOKUP}
                            view={businessPartner?.type?.name}
                            setInputReason={setInputReason}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.subType)}
                            disabled={checkPortalEditField(BusinePartnerEntity.subType) ? (companyHierarchy === LEVEL3_VALUE) : false}
                            mode={mode}
                            name={BusinePartnerEntity.subType}
                            options={subTypeOptions}
                            type={LOOKUP}
                            required={isRequiredField("bmw_AccountSubTypeId")}
                            view={businessPartner?.subType?.name}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.legalEntityType)}
                            mode={mode}
                            name={BusinePartnerEntity.legalEntityType}
                            options={allowedLegalEntityTypeOptions}
                            type={LOOKUP}
                            required={isRequiredField("bmw_legalentitytypeid")}
                            view={businessPartner?.legalEntityType?.name}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            disabled={isFieldDisabled(restrictedFields, BusinePartnerEntity.termOfCredit)}
                            label={fetchLabels(BusinePartnerEntity.termOfCredit)}
                            type={SELECT}
                            mode={mode}
                            options={termofcreditoptions}
                            name={BusinePartnerEntity.termOfCredit}
                            showPlaceholderOption={true}
                            view={businessPartner?.termOfCredit?.name}
                        />
                    </Grid>
                </Grid>
            </Section>

            {mode !== CREATE && (
                <Section>
                    <SectionTitle title="Status" />
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.nkamStatus)}
                                disabled={checkPortalEditField(BusinePartnerEntity.nkamStatus) ? false : disableStatusField}
                                mode={mode}
                                name={BusinePartnerEntity.nkamStatus}
                                options={filteredNkamOptions}
                                required={bPVatNotApplicable ? false : true}
                                type={SELECT}
                                view={businessPartner?.nkamStatus?.name}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled={checkPortalEditField(BusinePartnerEntity.downgradeReason) ? (!isDowngraded || greyMarketResult?.value === GreyMarketCheckResult_SellingNotAllowed) : !isDowngraded}
                                label={fetchLabels(BusinePartnerEntity.downgradeReason)}
                                mode={mode}
                                name={BusinePartnerEntity.downgradeReason}
                                options={downgradeReasonOptions}
                                required={isDowngraded}
                                type={SELECT}
                                view={businessPartner?.downgradeReason?.name}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled={checkPortalEditField(BusinePartnerEntity.downgradeDate) ? (!isDowngraded || greyMarketResult?.value === GreyMarketCheckResult_SellingNotAllowed) : !isDowngraded}
                                label={fetchLabels(BusinePartnerEntity.downgradeDate)}
                                mode={mode}
                                name={BusinePartnerEntity.downgradeDate}
                                required={isDowngraded}
                                type={DATE}
                                view={businessPartner?.downgradeDate}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled= {checkPortalEditField(BusinePartnerEntity.downgradeDescription) ? (!isDowngraded || greyMarketResult?.value === GreyMarketCheckResult_SellingNotAllowed) : !isDowngraded}
                                label={fetchLabels(BusinePartnerEntity.downgradeDescription)}
                                mode={mode}
                                name={BusinePartnerEntity.downgradeDescription}
                                required={isDowngraded && isPassedToRetailer}
                                type={TEXT}
                                view={businessPartner?.downgradeDescription}
                            />
                        </Grid>
                        {isFutureProspect && (
                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled={!(isFutureProspect && isDowngraded)}
                                    label={fetchLabels(BusinePartnerEntity.futureProspectDate)}
                                    mode={mode}
                                    name={BusinePartnerEntity.futureProspectDate}
                                    required={isFutureProspect}
                                    type={DATE}
                                    view={businessPartner?.futureProspectDate}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Section>
            )}
            {getShowCoinBool() && (
                <Section>
                    <SectionTitle title={t("coinSection.title")} />
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled={true}
                                label={fetchLabels(BusinePartnerEntity.coinCheckDate)}
                                mode={mode}
                                name={BusinePartnerEntity.coinCheckDate}
                                type={DATE}
                                view={businessPartner?.coinCheckDate}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled={true}
                                label={fetchLabels(BusinePartnerEntity.coinCheckResult)}
                                mode={mode}
                                name={BusinePartnerEntity.coinCheckResult}
                                type={TEXT}
                                view={
                                    coinResultStatuses[businessPartner?.coinCheckResult?.name] ||
                                    businessPartner?.coinCheckResult?.name
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled={true}
                                label={fetchLabels(BusinePartnerEntity.riskLevel)}
                                mode={mode}
                                name={BusinePartnerEntity.riskLevel}
                                type={TEXT}
                                view={businessPartner?.coinCheckRiskLevel?.name}
                            />
                        </Grid>
                    </Grid>
                </Section>
            )}
            {getShowGreySectionBool() && (
                <Section>
                    <SectionTitle title={t("greyMarketSection.title")} />
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.greymarketcheckperformed)}
                                mode={mode}
                                name={BusinePartnerEntity.greymarketcheckperformed}
                                type={CHECKBOX}
                                view={businessPartner?.greyMarketCheckPerformed}
                                disabled={!Boolean(isOwningRetailer)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.greymarketcheckdate)}
                                mode={mode}
                                name={BusinePartnerEntity.greymarketcheckdate}
                                type={DATE}
                                view={businessPartner?.greyMarketCheckDate}
                                disabled={!Boolean(isOwningRetailer) || !isGreyPerformed}
                                disableFuture={true}
                                required={Boolean(isGreyPerformed)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.greymarketcheckresult)}
                                mode={mode}
                                name={BusinePartnerEntity.greymarketcheckresult}
                                type={LOOKUP}
                                options={greyResultOptions}
                                view={
                                    businessPartner?.greyMarketCheckResult?.name
                                }
                                disabled={!Boolean(isOwningRetailer) || !isGreyPerformed}
                                required={Boolean(isGreyPerformed)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                label={fetchLabels(BusinePartnerEntity.alldocumentsprovided)}
                                mode={mode}
                                name={BusinePartnerEntity.alldocumentsprovided}
                                type={CHECKBOX}
                                view={businessPartner?.allDocumentsProvided}
                            />
                        </Grid>
                    </Grid>
                </Section>
            )}

            <Section>
                <SectionTitle
                    title={t("businessPartnerDetailPage.mainDetails.kamTitle")}
                />

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            disabled={
                                (mode === EDIT && showOwingKaminEdit) || mode === CREATE
                                    ? false
                                    : true
                            }
                            label={fetchLabels(BusinePartnerEntity.owningKAM)}
                            mode={mode}
                            name={BusinePartnerEntity.owningKAM}
                            options={owningKamServiceUsers}
                            type={LOOKUP}
                            required={true}
                            view={businessPartner?.owningKAM?.name}
                        />
                    </Grid>

                    {showOwningRetailerForBe && (
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled={
                                    checkPortalEditField(BusinePartnerEntity.owningRetailer) ? (companyHierarchy === LEVEL3_VALUE || (mode === EDIT && !isEditable) ): false }
                                label={fetchLabels(BusinePartnerEntity.owningRetailer)}
                                mode={mode}
                                name={BusinePartnerEntity.owningRetailer}
                                options={owningRetailerOptions}
                                type={LOOKUP}
                                view={owningRetailer?.name}
                                disableClearable={true}
                                isNotAlloedToViewValue={isFieldNotAllowedToViewValue(restrictedFields, BusinePartnerEntity.owningRetailer, mode)}
                            />
                        </Grid>
                    )}

                    {showOwningRetailerForBe && (
                        <Grid item xs={12} sm={4}>
                            <CustomControl
                                control={control}
                                disabled={checkPortalEditField(BusinePartnerEntity.owningRetailerContact) ? !isEditable : false} 
                                label={fetchLabels(BusinePartnerEntity.owningRetailerContact)}
                                mode={mode}
                                name={BusinePartnerEntity.owningRetailerContact}
                                options={owningRetailerContactOptions}
                                type={LOOKUP}
                                view={businessPartner?.owningRetailerContact?.name}
                                isNotAlloedToViewValue={isFieldNotAllowedToViewValue(restrictedFields, BusinePartnerEntity.owningRetailerContact, mode)}
                            />
                        </Grid>
                    )}
                </Grid>
            </Section>

            <Section>
                <SectionTitle title="ID's" />

                <Grid container spacing={3}>
                    {mode !== CREATE && (
                        <>
                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.globusId)}
                                    mode={mode}
                                    name={BusinePartnerEntity.globusId}
                                    type={TEXT}
                                    view={businessPartner?.globusId}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.ucid)}
                                    mode={mode}
                                    name={BusinePartnerEntity.ucid}
                                    type={TEXT}
                                    view={businessPartner?.ucid}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.gcdmId)}
                                    mode={mode}
                                    name={BusinePartnerEntity.gcdmId}
                                    type={TEXT}
                                    view={businessPartner?.gcdmId}
                                />
                            </Grid>
                        </>
                    )}

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={nationalId1Label}
                            mode={mode}
                            name={BusinePartnerEntity.nationalId1}
                            disabled={
                                cloneVatConfig && !bPVatNotApplicable ? true
                                    : cloneVatConfig && bPVatNotApplicable ? false
                                        : disableNationalID1
                            }
                            type={TEXT}
                            view={businessPartner?.nationalId1}
                            required={
                                bPVatNotApplicable ? isRequiredField(BusinePartnerEntity.nationalId1) :
                                    ((cloneVatConfig && !bPVatNotApplicable) || disableNationalID1) ? false :
                                        isRequiredField(BusinePartnerEntity.nationalId1)}
                            blur={nationalId1OnChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={nationalId2Label}
                            mode={mode}
                            name={BusinePartnerEntity.nationalId2}
                            type={TEXT}
                            view={businessPartner?.nationalId2}
                            required={isRequiredField(BusinePartnerEntity.nationalId2)}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={nationalId3Label}
                            mode={mode}
                            name={BusinePartnerEntity.nationalId3}
                            type={TEXT}
                            view={businessPartner?.nationalId3}
                            required={isRequiredField(BusinePartnerEntity.nationalId3)}
                        />
                    </Grid>
                    {mode !== CREATE && (
                        <>
                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    label={fetchLabels(BusinePartnerEntity.registrationOffice)}
                                    mode={mode}
                                    name={BusinePartnerEntity.registrationOffice}
                                    type={TEXT}
                                    view={businessPartner?.registrationOffice}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.dunsNumber)}
                                    mode={mode}
                                    name={BusinePartnerEntity.dunsNumber}
                                    type={TEXT}
                                    view={businessPartner?.dunsNumber}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Section>

            <Section>
                <SectionTitle title="More details" />
                <Grid container spacing={3}>
                    {mode !== CREATE && (
                        <>
                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.totalNumberOfEmployees)}
                                    mode={mode}
                                    name={BusinePartnerEntity.totalNumberOfEmployees}
                                    type={NUMBER}
                                    view={businessPartner?.totalNumberOfEmployees}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.totalNumberOfActiveRetailerRoles)}
                                    mode={mode}
                                    name={BusinePartnerEntity.totalNumberOfActiveRetailerRoles}
                                    type={NUMBER}
                                    view={businessPartner?.totalNumberOfActiveRetailerRoles}
                                />
                            </Grid>
                        </>
                    )}

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.fleetSize)}
                            mode={mode}
                            name={BusinePartnerEntity.fleetSize}
                            type={NUMBER}
                            inputProps={{
                                min: 0,
                                ...register(BusinePartnerEntity.fleetSize, {
                                    validate: {
                                        fleetsize: (value) =>
                                            value ? parseFloat(value) <= 1000000000 : true,
                                    },
                                }),
                            }}
                            view={businessPartner?.fleetSize}
                            title={t("businessPartnerDetailPage.mainDetails.fleetSizeTitle")}
                            register={register}
                            required={
                                companyHierarchy === LEVEL3_VALUE
                                    ? false
                                    : isRequiredField(BusinePartnerEntity.fleetSize)
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <CustomControl
                            control={control}
                            label={fetchLabels(BusinePartnerEntity.expectedVolume)}
                            mode={mode}
                            name={BusinePartnerEntity.expectedVolume}
                            type={NUMBER}
                            inputProps={{
                                min: 0,
                                ...register(BusinePartnerEntity.expectedVolume, {
                                    validate: {
                                        expectedVolume: (value) =>
                                            value ? parseFloat(value) <= 99999 : true,
                                    },
                                }),
                            }}
                            view={businessPartner?.expectedVolume}
                            title={t(
                                "businessPartnerDetailPage.mainDetails.expectedVolumeTitle",
                            )}
                            disabled={checkPortalEditField(BusinePartnerEntity.expectedVolume) ? true : false}
                            register={register}
                            required={checkPortalEditField(BusinePartnerEntity.expectedVolume) ? false : true }
                        />
                    </Grid>

                    {mode !== CREATE && (
                        <>
                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.confirmedCorporateCustomer)}
                                    mode={mode}
                                    name={BusinePartnerEntity.confirmedCorporateCustomer}
                                    type={CHECKBOX}
                                    view={businessPartner?.confirmedCorporateCustomer}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.employeeConfirmation)}
                                    mode={mode}
                                    name={BusinePartnerEntity.employeeConfirmation}
                                    type={CHECKBOX}
                                    view={businessPartner?.employeeConfirmation}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <CustomControl
                                    control={control}
                                    disabled
                                    label={fetchLabels(BusinePartnerEntity.receivesMotorradTerms)}
                                    mode={mode}
                                    name={BusinePartnerEntity.receivesMotorradTerms}
                                    type={CHECKBOX}
                                    view={businessPartner?.receivesMotorradTerms}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Section>

            {apiError?.isError && (
                <AppError apiError={apiError} setApiError={setApiError} />
            )}

            {showVatNotApplicableDialog && (
                <VatNotApplicableDialog
                    open={showVatNotApplicableDialog}
                    message={
                        bPVatNotApplicable
                            ? vatNotApplicableModalString
                            : vatNotApplicableModalMemo
                    }
                    handleOk={vatNotApplicablehandleOk}
                    handleClose={vatNotApplicablehandleClose}
                />
            )}
        </>
    );
};

export default BPMainDetails;
